"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemReader = void 0;
const uint256_1 = require("./uint256");
class MemReader {
    constructor(mem) {
        this.mem = mem;
    }
    get size() {
        return this.mem.length;
    }
    get(offset) {
        const ab = new ArrayBuffer(32);
        const view = new Uint8Array(ab);
        const max = Math.max(32, this.mem.length - offset - 32);
        for (let i = 0; i < max; i++) {
            view[31 - i] = this.mem[offset + i] ?? 0;
        }
        return (0, uint256_1.U256)(ab);
    }
    getByte(offset) {
        return this.mem[offset] ?? 0;
    }
    slice(offset, size) {
        const data = this.mem.slice(offset, offset + size);
        if (data.length >= size) {
            return new Uint8Array(data);
        }
        const ret = new Uint8Array(size);
        for (let i = 0; i < data.length; i++) {
            ret[i] = data[i];
        }
        return ret;
    }
    sliceNoPad(offset, size) {
        return new Uint8Array(this.mem.slice(offset, offset + size));
    }
}
exports.MemReader = MemReader;
//# sourceMappingURL=mem-reader.js.map